const complaintsReducer = (
  state = {
    loading: false,
    assetsLoading: false,
    exportLoading: false,
    paginationLoading: false,
    summaryLoading: false,
    summaryData: [],
    todayComplaintsCount: {},
    data: null,
    total: null
  },
  action
) => {
  switch (action.type) {
    case "SET_COMPLAINTS_LOADING":
      return {
        ...state,
        loading: action.payload.loading
      };

    case "SET_SUMMARY_LOADING":
      return {
        ...state,
        summaryLoading: action.payload.loading
      };

    case "SET_COMPLAINTS_PAGINATION_LOADING":
      return {
        ...state,
        paginationLoading: action.payload.loading
      };

    case "SET_COMPLAINT_COUNT_DATA":
      return {
        ...state,
        summaryData: action.payload.data
      };

    case "SET_COMPLAINTS_EXPORT_LOADING":
      return {
        ...state,
        exportLoading: action.payload.loading
      };

    case "SET_COMPLAINTS_ASSETS_LOADING":
      return {
        ...state,
        assetsLoading: action.payload.assetsLoading
      };

    case "SET_COMPLAINTS_DATA":
      return {
        ...state,
        data: action.payload.data
      };

    case "SET_COMPLAINTS_COUNT":
      return {
        ...state,
        total: action.payload.count
      };

    case "SET_TODAY_COMPLAINT_COUNT_DATA":
      return {
        ...state,
        todayComplaintsCount: action.payload.count
      };

    case "RESET":
      return state;

    default:
      return state;
  }
};
export default complaintsReducer;
